export const SET_USER = 'set_user';
export const SET_TOKEN = 'set_token';
export const SET_ROLE = 'set_role';
export const SET_PERMISSION = 'set_permission';